export const HREFVIDEO = "https://www.youtube.com/watch?v=x1S2HtEo1SE";